import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getUser } from '../store/slices/auth-slice'
import { useNavigate } from 'react-router-dom'

function AuthProvider({ children }: { children: React.ReactNode }) {
    const user: any = useSelector(getUser)
    const [loadPage, setLoadPage] = useState(false)
    const navigate = useNavigate()
    useEffect(() => {
        if (!user) {
            setLoadPage(false)
            navigate("/login")
        } else {
            setLoadPage(true)
        }
    }, [user, navigate])
    return <>
        {loadPage ? <div>{children}</div> : null}
    </>
}

export default AuthProvider